import * as React from "react";
import { forwardRef } from "react";
const SvgArrowup = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, "data-name": "icon/arrowdown", viewBox: "0 0 12 12", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M.736 0 0 .736 5.264 6 0 11.263.736 12l5.632-5.632L6.72 6l-.352-.368z", transform: "rotate(-90 4.664 4.663)", fill: "#98a9bc" }));
const ForwardRef = forwardRef(SvgArrowup);
export { ForwardRef as ReactComponent };
